import React from "react"
import HeadlineWithFocus from '../components/HeadlineWithFocus'
import Helmet from 'react-helmet'

import ToolBoxListContainer from '../containers/ToolBoxListContainer'

export default () => (
  <div className="c-content-box">
    <Helmet title="My developer toolbox" />  

    <HeadlineWithFocus modifierClassNames="c-headline-focus__bump"><span>Some gadgets in </span>my toolbox</HeadlineWithFocus>
    <ToolBoxListContainer />
   
  </div>
)


// WEBPACK FOOTER //
// ./src/pages/toolbox.jsx